module.exports = __webpack_public_path__ + "img/block_5.94781f59.png";